import React, { useMemo } from "react";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const EventHeroSection = ({ fields }) => {
    const sanitizedData = useMemo(() => {
        if (!fields) return null;

        const heading = sanitize(fields.heading || "");
        const description = sanitize(fields.description || "");

        const hasContent = heading || description;
        if (!hasContent) return null;

        return { heading, description };
    }, [fields]);

    if (!sanitizedData) return null;

    const { heading, description } = sanitizedData;

    // API images
    const desktopImg = fields?.background_image?.url || "";
    const mobileImg = fields?.background_image_mobile?.url || "";

    return (
        <section className="event_hero">
                <div className="event_hero_inner">
                    <div className="event_hero_image">
                        {/* Desktop image */}
                        {desktopImg && (
                            <img 
                                src={desktopImg}
                                alt={fields?.background_image?.alt || `${heading || "Event"} - Hero Background`}
                                className="event_hero_bg_img event_hero_bg_img_desktop"
                                fetchPriority="high"
                                loading="eager"
                            />
                        )}
                        {/* Mobile image */}
                        {mobileImg && (
                            <img 
                                src={mobileImg}
                                alt={fields?.background_image_mobile?.alt || `${heading || "Event"} - Hero Background Mobile`}
                                className="event_hero_bg_img event_hero_bg_img_mobile"
                                fetchPriority="high"
                                loading="eager"
                            />
                        )}

                        <div className="event_hero_overlay">
                            <div className="container">
                                <div className="overlay-content">
                                    {heading && <h1 className="banner-heading">{heading}</h1>}
                                    {description && <p>{description}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
};

export default EventHeroSection;
